import { useTheme } from '../lib/theme';
import { Icon } from './icons';
import { cn } from './ui';

/**
 * Theme switcher. `compact` shows only the sun/moon icon (square button), used in the
 * public + auth headers where horizontal space is tight; the labelled form stays in the
 * authed portal/admin sidebars where the bottom rail has room for the text.
 */
export function ThemeToggle({
  className,
  compact = false,
}: {
  className?: string;
  compact?: boolean;
}) {
  const theme = useTheme((s) => s.theme);
  const toggle = useTheme((s) => s.toggle);
  const dark = theme === 'dark';
  const label = dark ? 'Switch to light mode' : 'Switch to dark mode';
  return (
    <button
      type="button"
      onClick={toggle}
      title={label}
      aria-label={label}
      className={cn(
        'inline-flex h-9 items-center justify-center rounded-[10px] border border-border bg-panel2 text-muted transition hover:bg-hover hover:text-txt',
        compact ? 'w-9' : 'gap-2 px-3 text-[12px] font-medium',
        className,
      )}
    >
      {dark ? <Icon.Sun width={14} height={14} /> : <Icon.Moon width={14} height={14} />}
      {!compact && (
        <span className="font-mono uppercase tracking-[0.12em]">{dark ? 'Light' : 'Dark'}</span>
      )}
    </button>
  );
}
